import * as React from "react"
import { Link } from "gatsby"
import HappySkuie from "../svgs/happy-skuie.svg"
import Img from "gatsby-image"

const BlogCard = (props) => {
    
    return(
        <Link to={props.link} className='no-underline-on-hover mb-4'>
            <div className={`card flex-column h-100`}> {/* style={{minHeight:'20rem'}}> */}
                {props.featuredImage === null ?
                    <HappySkuie className='blog-image'/>
                    :
                    <Img className="sponsored-blog-image" fluid={props.image.fluid} alt={props.title} />
                }
                <div className={`card-body d-flex flex-column`}>
                    <p className="text-uppercase text-muted font-sm mb-3">
                        {props.category === null ? 
                            'Other' 
                            : 
                            props.category}
                    </p>
                    <p className="card-title text-uppercase text-header font-md mb-auto">{ props.title}</p>
                    <button className="btn btn-yellow mt-3 me-auto">Learn More</button>
                </div>
            </div>
        </Link>
    )
}

export default BlogCard;

